import script from "./BulkEditModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkEditModal.vue?vue&type=script&setup=true&lang=js"

import "./BulkEditModal.vue?vue&type=style&index=0&id=b8d1da92&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8d1da92"]])

export default __exports__